import React, {Component, useState} from 'react';
import ReactDOM from 'react-dom';
import {Router, Route, Switch} from 'react-router-dom';

import Aux from "../hoc/Auxiliary";
import UserContext from "../context/user-context";
import axios from "../axios-defaults";
//import { Detector, Offline, Online } from "react-detect-offline";

import routes from "../routes";

import Header from './Header';
import Header2 from './NotLogged/Header';
import Footer from './Footer';

import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumbs from '../components/Commons/Breadcrumbs';
import "../i18n"
import { withTranslation } from 'react-i18next';
import Spinner from "../components/UI/Spinner";
import {getTrackingUserId, isAgentSession, isHarnoisOrClient} from "../components/Utils/GTM/GTMHelper";
import { createBrowserHistory } from 'history';
import PrivacyPopup from "./PrivacyPopup/PrivacyPopup";

import {userHaveSpecificPermission} from "../components/Utils/UserHelper";
import ModalMxo from "../components/UI/Modal";

const history = createBrowserHistory();
/*

history.listen(() => {
    window.dataLayer.push({
        event: 'pageview'
    });
});
*/

class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            loadingNotifs: false,
            authenticated: true,
            user: {
                account: null,
                infos: null,
                paymentAllowed: false
            },
            userMessages : [],
            objDataLayer : null,
            sentDataLayer : false,
			showForceModal: false,
			newUserData: null,
			newAccountData: null
		}

		this.oldUserId = null;
		this.oldAccountCode = null;
    }

    componentDidMount() {
        this.getUser();
        this.getAccount();
        this.unlisten = history.listen((location, action) => {
            if(!(location.pathname.indexOf("/accounts/") > -1) &&
                !(location.pathname.includes("/accounts/change-account/add","/accounts/change-account")) && this.state.user.infos !== null){
                  this.sendDataLayerData(location,null);
            }
        });

		window.addEventListener('focus', this.checkUserChange);
    }

    componentDidUpdate() {
        if (this.state.user.infos !== null && this.state.user.account !== null && this.state.sentDataLayer === false && !(location.pathname.indexOf("/accounts/") > -1)) {
            this.sendDataLayerData(location,null);
            this.setState({sentDataLayer:true});
        }

    }

    componentWillUnmount() {
        this.unlisten();
		window.removeEventListener('focus', this.checkUserChange);
    }

    returnPageTitleDataLayer = () => {
        if(location.pathname.indexOf("/accounts") > -1){
            if(location.pathname === "/accounts/change-account"){
                return this.props.t('breadcrumbs.change_account');
            }else if(location.pathname === "/accounts/change-account/add"){
                return this.props.t('breadcrumbs.change_account_add');
            }else if(location.pathname === "/accounts"){
                return this.props.t('breadcrumbs.accounts');
            }else{
                return this.props.t('breadcrumbs.account');
            }
        } else if (location.pathname.indexOf("/profile") > -1) {
            return this.props.t('breadcrumbs.profile');
        } else{
            return this.props.t(routes.filter(item => item.path.indexOf(location.pathname) > -1)[0]?.name);
        }
    }

    sendDataLayerData = (location,addExtras= null) => {

        let items = {
            'event': 'page_view',
            'page_location': location.pathname,
            'page_title': this.returnPageTitleDataLayer(),
            'session_language': this.props.i18n.language,
        }


        if(this.state.user.infos !== null){
            items = {
                ...items,
                'user_session': isHarnoisOrClient(this.state.user.infos),
                'agent_session': isAgentSession(this.state.user.infos),
                'user_id': getTrackingUserId(this.state.user.infos),
            }
        }

        if(this.state.user.account !== null){
            items = {
                ...items,
                element_compte_category: this.state.user.account.classification?.descriptionFr,
                element_compte_category_code: this.state.user.account.classification?.code
            }
        }

        if(this.state.user.infos !== null && this.state.user.account !== null) {
            window.userGuiding.identify(this.state.user.infos.user_id, {
                //email: this.state.user.infos.email,
                agreed_condition_version: this.state.user.infos.agreed_condition_version,
                agreed_terms_version: this.state.user.infos.agreed_terms_version,
                portal_language: this.props.i18n.language,
                account_type: this.state.user.account.classification?.code,
                member_since: this.state.user.infos.created_at,
				financial_data_access: userHaveSpecificPermission(this.state.user, 'financial_data')
            })
        }

        if(addExtras !== null){
            items = {...items,...addExtras}
        }

        //console.log('obj SENT', items)
        window.dataLayer.push(items);
    }

    setDataLayerData = (items) =>{
        this.sendDataLayerData(window.location,items);
    }

    getAccount = async () => {
        this.setState({loading:true});
        await axios.get("/accounts")
            .then(response => {

                //console.log('[App.js] user account',response.data);
                if(response.data.succeeded) {
                    this.setState({
                        user: {
                            ...this.state.user,
                            account: response.data.data
                        }
                    });

					if (this.oldAccountCode === null) {
						this.oldAccountCode = response.data.data?.accountCode || null;
					}

                    if (response.data.data.accountCode != null) {
                        this.getPaymentAllowed();
                        this.getUserMessagesNotifications();
                    }
                }
                this.setState({loading:false});
            }).catch(error => {
                this.setState({loading:false});
                console.log('[App.js] : Ajax error in getAccount()',error.message);
            });
    }

    getUser = async() => {
        this.setState({loading:true});
        await axios.get("/user")
            .then(response => {
                //console.log('[App.js] user infos',response.data);
                if(response.data.succeeded) {
                    this.setState({
                        user: {
                            ...this.state.user,
                            infos: response.data.data
                        }
                    });

					if (this.oldUserId === null) {
						this.oldUserId = response.data.data?.user_id || null;
					}
                    // old datalayer spot
                    /*
                    if(!(location.pathname.indexOf("/accounts/") > -1)){
                        this.sendDataLayerData(window.location, {
                            'user_session': this.isHarnoisOrClient(response.data.data),
                            'agent_session': this.isAgentSession(response.data.data),
                        });
                    }*/
                }

                this.setState({loading:false});
            }).catch(error => {
            this.setState({loading:false});
            console.log('[App.js] : Ajax error in getUser()',error.message);
        });
    }

    getPaymentAllowed = async() => {
        this.setState({loading:true});
        await axios.get("/accounts/subaccounts")
            .then(response => {

                //console.log('[App.js] user subaccounts',response.data);
                if(response.data.succeeded){
                    let canPay = response.data.data.some(function (item) {
                        return item.isOnlinePaymentAllowed;
                    });

					let canPayCard = response.data.data.some(function (item) {
						return item.isOnlinePaymentCreditCardAllowed;
					});

					let canPayEft = response.data.data.some(function (item) {
						return item.isOnlinePaymentEFTAllowed;
					});

                    this.setState({
                        user: {
                            ...this.state.user,
                            paymentAllowed: canPay,
							paymentCardAllowed: canPayCard,
							paymentEftAllowed: canPayEft
                        }
                    });
                }
                this.setState({loading:false});
            }).catch(error => {
                this.setState({loading:false});
                console.log('[App.js] : Ajax error in getPaymentAllowed()',error.message);
            });
    }

    getUserMessagesNotifications = async() => {

        this.setState({loadingNotifs:true});
        await axios.get(`/messages?pageSize=5`)
            .then(response => {
                // noinspection JSUnresolvedVariable
                if (response.data.succeeded)  {
                    let messagesCollection = response.data.data;
                    if (messagesCollection.messages.length) {
                        let itemsArr = [];
                        messagesCollection.messages.forEach((item) => {
                            let newItem = {
                                id: item.id,
                                read: (item.read === 1),
                                date: item.created_at,
                                title_fr: item.title_fr,
                                message_fr: item.message_fr,
                                excerpt_fr: item.excerpt_fr,
                                title_en: item.title_en,
                                message_en: item.message_en,
                                excerpt_en: item.excerpt_en
                            };
                            itemsArr.push(newItem)
                        });
                        this.setState({userMessages: {
                            count : messagesCollection.unread_messages_count,
                            messages : itemsArr
                        }});
                        this.setState({loadingNotifs: false });
                    }
                }
            }).catch(error => {
                console.log('[App.js] : Messages ajax error in getUserMessagesNotifications()', error.message)
                this.setState({loadingNotifs:false})
            });
    }

	//Check if the user has changed and reload the page on focus if necessary in case of multiple open tabs
	checkUserChange = async () => {

		try {
			// Get both user and account data in parallel
			const [userResponse, accountResponse] = await Promise.all([
				axios.get("/user"),
				axios.get("/accounts")
			]);

			const userData = userResponse.data.succeeded ? userResponse.data.data : null;
			const accountData = accountResponse.data.succeeded ? accountResponse.data.data : null;

			const newUserId = userData?.user_id || null;
			const newAccountCode = accountData?.accountCode || null;

			// Check if either user or account has changed
			if ((this.oldUserId && newUserId && newUserId !== this.oldUserId) ||
				(this.oldAccountCode && newAccountCode && newAccountCode !== this.oldAccountCode)) {

				// Store both sets of data regardless of which one triggered the change
				this.setState({
					showForceModal: true,
					newUserData: userData,
					newAccountData: accountData
				});
			}
		} catch (e) {
			console.warn("checkUserChange error:", e.message);
		}
	};

	handleOkClick = () => {
		window.location.reload();
	};


    render() {
        const OFFLINER = () => (
            <div>
                <span className="icon" style={{fontSize:"15px",width:"20px",display:"inline-block"}}>
                    <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="wifi-slash" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" className="svg-inline--fa fa-wifi-slash fa-w-20 fa-5x"><path fill="currentColor" d="M36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.53-6.9 4.41-16.97-2.49-22.49L36 3.51zm467.18 304.31c1.77-.6 3.67-.83 5.05-2.29l16.46-17.37c4.62-4.87 4.38-12.64-.58-17.15-47.67-43.38-105.71-68.61-165.55-76.26l144.62 113.07zm100.09-118.96c4.8 4.39 12.29 4.13 16.81-.54l16.6-17.19c4.65-4.81 4.37-12.43-.57-16.95C509.51 38.38 333.7 5.4 178.62 54.08l46.71 36.52c130.7-29.93 273.12 2.51 377.94 98.26zM3.89 154.18c-4.94 4.52-5.22 12.14-.57 16.95l16.6 17.19c4.52 4.68 12.01 4.93 16.81.54 12.72-11.62 26.16-21.97 39.9-31.74L37.34 126.4c-11.47 8.69-22.66 17.91-33.45 27.78zm112 116.83c-4.96 4.52-5.2 12.28-.58 17.15l16.46 17.37c4.46 4.71 11.81 4.95 16.62.6 19.7-17.81 41.53-31.84 64.54-42.46l-41.51-32.45c-19.55 11.03-38.28 24.09-55.53 39.79zM240 400c0 44.18 35.82 80 80 80 41.03 0 74.45-31 79.07-70.79l-107.24-83.84C261.6 336.79 240 365.77 240 400zm80-32c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.36-32 32-32z" className=""></path></svg>
                </span>
                &nbsp; {this.props.t('misc.offline_msg')}
                <small style={{fontSize:'70%',fontWeight:'normal',lineHeight:1.15,display:'block',marginTop:'0.5rem'}}>
                    {this.props.t('misc.offline_msg_sub')}
                </small>
            </div>
        );

        const ONLINER = () => (
            <div>
                <span className="icon" style={{fontSize:"15px",width:"20px",display:"inline-block"}}>
                    <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="wifi" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" className="svg-inline--fa fa-wifi fa-w-20 fa-7x"><path fill="currentColor" d="M320 368c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.36-32-32 14.35-32 32-32m0-48c-44.18 0-80 35.82-80 80s35.82 80 80 80 80-35.82 80-80-35.82-80-80-80zm204.69-31.83c4.62-4.87 4.38-12.64-.59-17.15-115.74-105.32-292.41-105.38-408.22 0-4.96 4.51-5.2 12.28-.59 17.15l16.47 17.37c4.46 4.71 11.81 4.95 16.62.6 97.44-88.13 245.68-88.21 343.22 0 4.81 4.35 12.16 4.1 16.62-.6l16.47-17.37zm111.42-133.98C457.86-8.86 181.84-8.59 3.89 154.19c-4.94 4.52-5.22 12.14-.57 16.95l16.6 17.18c4.52 4.68 12.01 4.93 16.81.54 159.59-145.79 406.82-145.91 566.54 0 4.81 4.39 12.29 4.13 16.81-.54l16.6-17.18c4.65-4.81 4.37-12.44-.57-16.95z" className=""></path></svg>
                </span>
                &nbsp; {this.props.t('misc.online_msg')}
            </div>
        );
        if (this.state.user) {
            return (
                <Router history={history}>
                    <UserContext.Provider value={{authenticated:this.state.authenticated, user:this.state.user}}>

                        {location.pathname != '/faq-ug' &&
                            ((this.state.user.account != null) ?
                                <Header
                                    loadingNotifs={this.state.loadingNotifs}
                                    notificationMessages={this.state.userMessages}
                                />
                                : <Header2 />)
                        }
                        <div className="content" id="app-content">
                            <Switch>
                                {routes.map(({ path, name, Component }, key) => (
                                    <Route
                                        exact
                                        path={path}
                                        key={key}
                                        render={props => {

                                            let crumbs = [];
                                            const hasAccount = this.state.user.account;
                                            if (hasAccount && typeof hasAccount === 'object' && Object.keys(hasAccount).length) {
                                                crumbs = routes
                                                    // Get all routes that contain the current one.
                                                    .filter(({ path }) => props.match.path.includes(path))
                                                    // Swap out any dynamic routes with their param values.
                                                    // E.g. "/accounts/:accountId" will become "/accounts/523554"
                                                    .map(({ path, ...rest }) => ({
                                                        path: Object.keys(props.match.params).length
                                                            ? Object.keys(props.match.params).reduce(
                                                                (path, param) =>
                                                                    path.replace(`:${param}`, props.match.params[param]),
                                                                path
                                                            )
                                                            : path,
                                                        ...rest
                                                    }));
                                            }

                                            return (
                                                <Aux>
                                                    {location.pathname != '/faq-ug' && <Breadcrumbs crumbs={crumbs} />}
                                                    <Component {...props} setDataLayerData={this.setDataLayerData}
															   user={this.state.user}
                                                               updateUserNotif={this.getUserMessagesNotifications} />
                                                </Aux>
                                            );
                                        }}
                                    />
                                ))}
                            </Switch>
                        </div>
                        {location.pathname != '/faq-ug' && <Footer/>}
                        {location.pathname != '/faq-ug' && <PrivacyPopup />}
                    </UserContext.Provider>

                    {/* disabled detector for now
                    <Detector render={({ online }) => {
                        if(!online){
                            //this.updateOnlineStatus(false);
                            return toast.error(OFFLINER,{autoClose: false });
                        } else{
                            toast.dismiss();
                        }
                        return '';
                    }}/>
                    */}

                    <ToastContainer
                        position="bottom-center"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss={false}
                        draggable
                        pauseOnHover
                    />
					{this.state.showForceModal && (
						<ModalMxo
							show={true}
							onHide={() => {}}
							backDrop="static"
							keyboard={false}
							showCloseButton={false}
							hideFooter={false}
							title={this.props.t('payment.popup.titlewarning')}
							footerActions={
								<div className="modal-footer d-flex justify-content-end">
									<button
										className="btn btn--raised btn--raised--red"
										onClick={this.handleOkClick}
									>
										OK
									</button>
								</div>
							}
						>
							<p>
								{this.props.t('popup.force_reload_msg', {
									accountName: this.state.newAccountData?.name || '',
									userName: this.state.newUserData ? `${this.state.newUserData.firstname || ''} ${this.state.newUserData.lastname || ''}` : '',
									accountCode: this.state.newAccountData?.accountCode ? `#${this.state.newAccountData?.accountCode} ${this.props.t('popup.force_reload_msg_as')}` : ''
								})}
							</p>
						</ModalMxo>
					)}
                </Router>
            );
        } else {
            return (<Spinner styleName="fixed"/>);
        }
    }
}

const TrApp = withTranslation()(App)

if (document.getElementById('app')) {
    ReactDOM.render(<TrApp/>, document.getElementById('app'))
}
